const data = [
    {
        id: 1,
        title: 'Мерлин иронично заметила:',
        desc: 'Будь доброжелательней: сделай куклу Вуду своего соседа и пожелай ему хорошего дня!'
    },
    {
        id: 2,
        title: 'Мерлин иронично заметила:',
        desc: '+100 к харизме. Твои посты соберут гораздо больше лайков. Проверь хоть сейчас!'
    },
    {
        id: 3,
        title: 'Мерлин иронично заметила:',
        desc: 'Любишь телепортироваться — люби и пространственно-временные перекосы исправлять!'
    },
    {
        id: 4,
        title: 'Мерлин иронично заметила:',
        desc: 'Магия и квантовая физика идут рука об руку. Нужно лишь только забыть всю квантовую физику.'
    },
    {
        id: 5,
        title: 'Мерлин иронично заметила:',
        desc: 'Когда снова соберёшься вызвать дух Наполеона — не забудь уточнить, что это не пирожное. А то будет как в прошлый раз…'
    },
    {
        id: 6,
        title: 'Артур от всей души пожелал:',
        desc: 'Ты не вывозишь ситуацию, потому что она прибита к полу огромным гвоздём. Представь, что гвоздя нет.'
    },
    {
        id: 7,
        title: 'Артур от всей души пожелал:',
        desc: 'Не трать время на гадалок! Ты и без их помощи можешь себя обмануть!'
    },
    {
        id: 8,
        title: 'Артур от всей души пожелал:',
        desc: 'Эта карта ничего не предсказывает. Короче, делай что хочешь и сам отвечай за свои поступки.'
    },
    {
        id: 9,
        title: 'Артур от всей души пожелал:',
        desc: 'Наблюдательность детектива. Ты найдешь пульт от телевизора. Но если там он уже показывает 2х2 – зачем тебе вообще искать пульт?'
    },
    {
        id: 10,
        title: 'Анна сказала:',
        desc: 'Тебе досталась карта неизбежности. Рано или поздно тебе всё-таки придётся пропылесосить за диваном :('
    },
    {
        id: 11,
        title: 'Анна сказала:',
        desc: 'Вы разблокировали новую магическую способность — мыть посуду с удовольствием. Попробуйте прямо сейчас!'
    },
    {
        id: 12,
        title: 'Анна сказала:',
        desc: 'Теперь доставка приезжает к тебе на 10% быстрее. Правда это значит, что теперь курьеры любят тебя на 10% меньше.'
    },
    {
        id: 13,
        title: 'Анна сказала:',
        desc: 'Предсказание на ближайшее будущее ты получишь от бабушек у подъезда. Просто спроси у них, когда пойдёшь выносить мусор.'
    },
    {
        id: 14,
        title: 'Анна сказала:',
        desc: 'Вы разблокировали новую магическую способность – мыть посуду с удовольствием. Попробуйте прямо сейчас!'
    },
    {
        id: 15,
        title: 'Ви радостно прокричала:',
        desc: '+100 к Удаче. Когда включишь 2х2, там обязательно будет идти одно из твоих любимых шоу!'
    },
    {
        id: 16,
        title: 'Ви радостно прокричала:',
        desc: 'Вам достаётся суперспособность — гадание на кошачьей шерсти: если на вашем свитере её нет, значит у вас нет кота.'
    },
    {
        id: 17,
        title: 'Ви радостно прокричала:',
        desc: 'Обнимашки! Раз в день ты можешь получить бесплатные обнимашки! Бесплатные также означают, что ТЕБЕ за них не заплатят.'
    },
    {
        id: 18,
        title: 'Ви радостно прокричала:',
        desc: 'Время приключений… а не мытья посуды! Раз в неделю можешь отказаться от мытья посуды, потому что тебя ждут приключения!'
    },
    {
        id: 19,
        title: 'Давид задумчиво произнёс:',
        desc: 'Ты получаешь суперсилу — способность умножать в уме 17-значные числа. Но эта способность работает только 4 секунды в день. И включается произвольно.'
    },
    {
        id: 20,
        title: 'Давид задумчиво произнёс:',
        desc: 'Далеко пойдёт! Отныне все говорят о тебе только хорошее! Все считают, что ты ДАЛЕКО ПОЙДЁШЬ и не хотят, чтобы ты шёл подальше!'
    },
    {
        id: 21,
        title: 'Давид задумчиво произнёс:',
        desc: '+100 к Интеллекту. Теперь ты достаточно умный, чтобы понимать: надо было брать +100 к Богатству.'
    },
    {
        id: 22,
        title: 'Давид задумчиво произнёс:',
        desc: 'Читать мысли очень просто. Просто у всех у нас в головах разные кодировки, и шрифты не читаются.'
    },
    {
        id: 23,
        title: 'Баюн лениво промурлыкал:',
        desc: 'Дополнительная лень. Ты можешь лениться на 1 час в день больше, и тебе за это ничего не будет (но ничего хорошего тоже – тут уж извини).'
    },
    {
        id: 24,
        title: 'Баюн лениво промурлыкал:',
        desc: 'Если ты до сих пор не можешь открыть усилием воли даже холодильник, то тяни следующую карту.'
    },
    {
        id: 25,
        title: 'Баюн лениво промурлыкал:',
        desc: 'Мои тефтели! Раз в день объяви любую еду на столе своей. Возможно, у тебя станет меньше друзей, зато больше еды и веса в обществе.'
    },
    {
        id: 26,
        title: 'Баюн лениво промурлыкал:',
        desc: 'Кость пушистая! Теперь у тебя есть официальное объяснение паре лишних килограмм!'
    },
    {
        id: 27,
        title: 'Елена произнесла:',
        desc: 'Скоро у тебя появится свой личный мистический ондатр. Не забудь купить ему стеклянный шар и колоду карт.'
    },
    {
        id: 28,
        title: 'Музы весело крикнули:',
        desc: 'Ммм, амброзия! Всё кажется тебе на 10% вкуснее. Если не заметил разницы, значит, ты ешь что-то на 10% менее вкусное.'
    },
    {
        id: 29,
        title: 'Кама громко отрапортовал:',
        desc: 'Воин-лучник. Ты становишься на 50% более метким. Если всё ещё промахиваешься, представляешь, НАСКОЛЬКО бы ты промахнулся без этого бафа?'
    },
    {
        id: 30,
        title: 'Шеф Сингуляров прорычал:',
        desc: 'Алло, вас беспокоит служба безопасности банка. Вы получаете на 50% меньше звонков от мошенников! Чтобы избавиться от 100%, переведите деньги на…'
    },
    {
        id: 31,
        title: 'Мойры прошептали:',
        desc: 'Добавь волшебства в жизнь — заколдуй свою бабушку.'
    },
    {
        id: 32,
        title: 'Мойры прошептали:',
        desc: 'Помощь судьбы. Уже чувствуешь? Отныне у любого твоего начинания гораздо выше шансы на успех.'
    },
    {
        id: 33,
        title: 'Ульрих изобразил жестами:',
        desc: 'Исполнение желаний! Твое желание непременно исполнится, если целый год ты будешь смотреть только 2х2 и ничего больше!'
    },
    {
        id: 34,
        title: 'Гермес улыбаясь произнёс:',
        desc: 'Мои Таларии! Ты становишься быстрее на 0,001%. Но окружающим с их медлительностью будет сложно заметить эту разницу.'
    },
]

export default data;